import { Box, Divider, Container } from '@hover/blueprint';
import React, { FC } from 'react';
import SearchBarDesktop from './SearchBarDesktop';
import SearchBarMobile from './SearchBarMobile';

interface Props {
  handleSubmit: Function;
  hideBottomDivider?: boolean;
}

const SearchBar: FC<Props> = ({ handleSubmit, hideBottomDivider }) => (
  <>
    <Box display={{ base: 'none', desktop: 'block' }} w="100%">
      <SearchBarDesktop handleSubmit={handleSubmit} pt={800} pb={600} />
      {hideBottomDivider ? null : (
        <Divider color="neutral.300" orientation="horizontal" opacity={1} />
      )}
    </Box>
    <Container px={0} display={{ base: 'block', desktop: 'none' }} maxW="100%">
      <SearchBarMobile handleSubmit={handleSubmit} />
      {hideBottomDivider ? null : (
        <Divider color="neutral.300" orientation="horizontal" opacity={1} />
      )}
    </Container>
  </>
);

SearchBar.defaultProps = {
  hideBottomDivider: false,
};

export default SearchBar;
